module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reviews_count":"리뷰 {count}"}}')
  delete Component.options._Ctor
}
